import UtilityService from "../services/UtilityService";
import EnhancedProductService from "../services/enhanced/EnhancedProductService";
const useStrict = '"use strict";';
let quoteType = "201";
let orderType = "203";

// prettier-ignore
export function legacyAddToCart(itemNumber, quantity, scID, productCAD, type, productVariantCharacteristics) {
  legacyGetWeco(function(w){
    quoteType = w.wecoQuoteType;
    orderType = w.wecoOrderType;
    const prType = type == "quote" ? quoteType : orderType;
    w.wecoAddToCart(itemNumber, itemNumber, quantity, scID, productCAD, undefined, prType, undefined, productVariantCharacteristics);
  });
}

export function legacyAddToCartMultiItem(
  type,
  itemArray,
  productVariantCharacteristics
) {
  legacyGetWeco(function(w) {
    quoteType = w.wecoQuoteType;
    orderType = w.wecoOrderType;
    const prType = type == "quote" ? quoteType : orderType;
    w.wecoAddToCart(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      prType,
      _formattedItemArray(itemArray),
      productVariantCharacteristics
    );
  });
}

export function legacyCartCount() {
  let count = 0;
  if (window.__weco !== undefined) {
    count = window.__weco.wecoCartCount();
  }
  return count;
}
export function legacyGetWeco(fn) {
  const fnString = `require(['sitecoreweco'], function(w) { window.__weco = w })`;
  Function(useStrict + "return (" + fnString + ")")();

  function check() {
    if (window.__weco === undefined) {
      setTimeout(check, 1); //wait 1 millisecnds then recheck
      return;
    }
    fn(window.__weco);
    //delete window.__weco;
  }
  check();
}

// prettier-ignore
export function legacyGetCurrentDocType() {
  return typeof window.top.currentDocType == "function" && window.top.currentDocType();
}

export function legacyIsQuote() {
  return legacyGetCurrentDocType() === quoteType;
}

export function legacyClearCart(itemNumber, quantity, scID, productCAD, type) {
  legacyGetWeco(function(w) {
    if (window.__weco !== undefined) {
      w.wecoClearCart(itemNumber, quantity, scID, productCAD, type);
    }
  });
}

export function legacyClearCartMultiItem(type, itemArray) {
  legacyGetWeco(function(w) {
    if (window.__weco !== undefined) {
      w.wecoClearCart(
        undefined,
        undefined,
        undefined,
        undefined,
        type,
        _formattedItemArray(itemArray)
      );
    }
  });
}

// helper functions
function _formattedItemArray(arr) {
  return arr.map(item => {
    const PartName = item.PartName ? item.PartName : item.Value;
    const IsProductVariant = item.IsProductVariant ? "Y" : "N";
    const Quantity = item.DefaultQuantity;
    const productCAD = item.Price.RawPrice;

    return {
      ...item,
      PartName,
      IsProductVariant,
      Quantity,
      productCAD
    };
  });
}

// NOTE 11/17/2020: TODO since we are no longer calling this on add to cart, move this function and its helpers
// probably rename the function as well
export function formatEnhancedMapQuoterOrderArray(arr, store) {
  const { getters } = store;
  const variantItem = arr.filter(item => true === item.IsProductVariant);
  const CustomerNumber = getters["user/getUser"]
    ? getters["user/getUser"].CustomerNumber
    : null;
  const NotesGetter = getters["enhancedBom/getBomNoteText"];
  const Notes = UtilityService.excapeDangerousCharacters(NotesGetter);
  // If there is a variantItem where IsProductVariant is true, the PartName is the VariantPartNumber if not, its null
  const variantItemPartNumber = variantItem[0] ? variantItem[0].PartName : null;

  const EnhancedMapQuoterOrderList = arr.map(i => {
    const PartName = _getPartName(i);
    // TODO: find the typo and fix the data, for now _getDefinedPosition works
    const PositionFix = _getDefinedPosition(i);
    const Position = Array.isArray(PositionFix)
      ? PositionFix.toString()
      : PositionFix;

    return {
      CreateDate: null,
      CustomerNumber,
      Description: i.Description,
      Notes,
      PartName,
      Position,
      Quantity: i.DefaultQuantity,
      UpdateDate: null,
      VariantPartNumber: variantItemPartNumber
    };
  });

  EnhancedProductService.addMAPOrderQuoteDetails(EnhancedMapQuoterOrderList)
    .then(response => {
      // because this call is behind the scenes, I don't think we need to do anything to the UI
      return response;
    })
    .catch(e => {
      // I don't think we will be handling an error with this call unless we want to prevent adding to cart if it fails
      return e;
    });
}

function _getDefinedPosition(item) {
  if (undefined === item.Postion) {
    return item.Position;
  }
  if (undefined === item.Position) {
    return item.Postion;
  }
  throw new Error("Unable to determine position for item ", item);
}

function _getPartName(item) {
  if (undefined === item.PartName) {
    return item.Value;
  }

  return item.PartName;
}
